/**
 * 文章頁數監控
 * @param {頁數資料} data 
 * @param {頁數更換方法} changePageFn 
 */
function pagePropertyListener(data, changePageFn) {
  // 頁數監控
  Object.defineProperty(data, "currentPage", {
    get: function () {
      return data._currentPage;
    },
    set: function (value) {
      if (data._currentPage > data.max_page) {
        data._currentPage = data.max_page;
      } else if (data._currentPage < 1) {
        data._currentPage = 1;
      } else {
        data._currentPage = value;
      }
      changePageFn();
    },
  });
}

/**
 * 狀態監控
 */
// function propertyListener() {
//   // 讀取狀態監控
//   Object.defineProperty(loadingData, "isLoading", {
//     get: function () {
//       return loadingData._isLoading;
//     },
//     set: function (value) {
//       loadingData._isLoading = value;
//       setLoading(loadingData.isLoading);
//     },
//   });
// }

/**
 * 略縮圖輪播圖狀態監控
 * @param {輪播圖頁數資料} data 
 * @param {上層 swiper} swiperTop 
 */
function thumbsSwiperListener(data, swiperTop) {
  const maxLength = swiperTop.slides.length;

  Object.defineProperty(data, "index", {
    get: function () {
      return data._index;
    },
    set: function (value) {
      if (value < 0) {
        data._index = maxLength - 1;
      } else if (value >= maxLength) {
        data._index = 0;
      } else {
        data._index = value;
      }
      swiperTop.slideTo(data.index);
    },
  });
}

export { pagePropertyListener, thumbsSwiperListener };
